import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { StaffComplianceOverview } from '@/features/staff/compliance-overview'
import { requireActiveSubscription } from '@/lib/middleware'

const complianceSearchSchema = z.object({
  // Compliance Phase 3c: the Training destination opens on the matrix (the mock's
  // first tab); the table that lived here alone is the second tab, params intact.
  tab: z.enum(['matrix', 'overview']).optional().catch('matrix'),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(25),
  search: z.string().optional().catch(''),
  status: z.string().optional().catch(undefined),
  team: z.string().optional().catch(undefined),
  role: z.string().optional().catch(undefined),
  columns: z.enum(['mandatory', 'mandatory_and_role', 'all']).optional().catch('mandatory_and_role'),
  blockedOnly: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/staff/compliance'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: StaffComplianceOverview,
  validateSearch: complianceSearchSchema,
})
